/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit HelpAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import TysiaIconHelpFilled from 'DesignSystem/Svgs/TysiaIconHelpFilled/index'



/** @type {import('Simple/types.js').View} */
export default function HelpAction({
  children,
  viewPath = "/DesignSystem/EditAutomation/AutomationType/HelpAction"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="ghost"
 size="small"
 onClick={flow.has(fromFlow.normalizePath(viewPath, '../HelpText/Content')) ? () => setFlowTo(fromFlow.normalizePath(viewPath, '../HelpText/No')) : () => setFlowTo(fromFlow.normalizePath(viewPath, '../HelpText/Content'))}
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<TysiaIconHelpFilled
{...childProps}
  viewPath={`${viewPath}/TysiaIconHelpFilled`}
 width={14}
 height={14}
 fill={dtColorsNeutral500}
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
{children}
</React.Fragment>)
}